import { useContext, useEffect, useState } from 'react';

import styles from './HisotoryOrdersPage.module.css';



import ConnUrls from '../../../../../MyConns/Connections/ConnectURL';
import { TheMasterContext } from '../../../../MyContexts/Master_Context';
import { MobiOrNotContext } from '../../../../MyContexts/MobiOrNot_Context';
import myFunctions from '../../../../../myFunctions';
import MyDateTime from '../../../../MySections/TimeSections/MyDateTime';

const OrdersHistoryItem = (props) => {
    const [master, setMaster] = useContext(TheMasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser] = useState();
    const [specialUser, setSpecialUser] = useState();
    const [theOrder, setTheOrder] = useState(props.theordr);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);

    const [loading, setLoading] = useState(true);
    const [remarks, setRemarks] = useState("");



    useEffect(() => {

        setUser(theOrder.user.parentUser ? theOrder.user.parentUser : theOrder.user)

        setSpecialUser(theOrder.user.parentUser ? theOrder.user : null)
        setLoading(false)
    }, [theOrder]);


    useEffect(() => {

    }, [])



    let delPrc = 0;


    return (
        !loading &&
        <>
            <div className={"finishOrdrPage spaceMargeTop_10 inColorBlack"}>
                <div className="fullRow">
                    <div className="fullRow">
                        <div className="bold big onRight">מספר הזמנה: {theOrder.orderNUM}</div>
                    </div>
                    <div className={"dottedLineSpacer catal spaceMargeTop_5"}></div>

                </div>
                <div className="">
                    <div className="bold big spacePaddingBottom_5">פרטי הלקוח</div>
                    <div className="fullRow spaceMargeTop_5">
                        <div className="onRight">
                            <span className="bold">שם מלא: </span>
                            {!specialUser || (Object.keys(specialUser).length === 0) ?
                                <span>{`${user.firstName} ${user.lastName}`}</span>
                                :
                                <span>{`${specialUser.firstName} ${specialUser.lastName}`}</span>
                            }
                        </div>
                    </div>
                    <div className="fullRow spaceMargeTop_5">
                        <div className="onRight">
                            <span className="bold">טלפון: </span>
                            {!specialUser || (Object.keys(specialUser).length === 0) ?
                                <span className={""}><a className={"noDecoration"} href={`tel:${user.phone}`}>{user.phone}</a></span>
                                :
                                <span className={""}><a className={"noDecoration"} href={`tel:${specialUser.phone}`}>{specialUser.phone}</a></span>
                            }

                        </div>
                    </div>

                    {!specialUser || (Object.keys(specialUser).length === 0) ? user.email &&
                        <div className="fullRow spaceMargeTop_5">
                            <div className="onRight">
                                <span className="bold">אימייל: </span>
                                <span className={""}><a className={"noDecoration"} href={`mailto:${user.email}`}>{user.email}</a></span>
                            </div>
                        </div>
                        :
                        <div className="fullRow spaceMargeTop_5">
                            <div className="onRight">
                                <span className="bold">אימייל: </span>
                                <span className={""}><a className={"noDecoration"} href={`mailto:${specialUser.email}`}>{specialUser.email}</a></span>
                            </div>
                        </div>
                    }

                </div>
                <div className="">
                    <div className="fullRow">
                        <div className={"dottedLineSpacer catal spaceMargeTop_5"}></div>

                        <div className="bold big onRight">מועד הגעה</div>
                    </div>
                    <div className="fullRow spaceMargeTop_5">
                        <div className="onRight">
                            <span className="bold">תאריך: </span>
                            {/* <span>{theOrder.dateToDeliver}</span> */}
                            <span>{MyDateTime.getDate(theOrder.dateToDeliver)}</span>
                        </div>
                        <div className="onRight spaceMargeRight_10">
                            <span className="bold">שעה: </span>
                            <span>{MyDateTime.getShortTime(theOrder.dateToDeliver)}</span>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="fullRow">
                        <div className={"dottedLineSpacer catal spaceMargeTop_5"}></div>

                        {theOrder.OrderType === "Deliver" ?
                            <div className="bold big onRight">פרטי המשלוח</div> :
                            <div className="bold big onRight">איסוף עצמי</div>
                        }

                    </div>
                    {
                        (theOrder.OrderType === "Deliver") &&
                        <>
                            <div><span className="bold">עיר: </span>
                                <span>{theOrder.deliveryAddress.city}</span>
                            </div>
                            <div className="fullRow">
                                <div className="onRight">
                                    <span className="bold">רחוב: </span>
                                    <span>{theOrder.deliveryAddress.street}</span>
                                </div>
                                <div className="onRight spaceMargeRight_10">
                                    <span className="bold">מספר: </span>
                                    <span>{theOrder.deliveryAddress.num}</span>
                                </div>
                            </div>

                            <div className="fullRow">
                                {theOrder.deliveryAddress.appartment &&
                                    theOrder.deliveryAddress.appartment !== "" &&
                                    <div className="onRight">
                                        <span className="bold">דירה: </span>
                                        <span>{theOrder.deliveryAddress.appartment}</span>
                                    </div>
                                }
                                {theOrder.deliveryAddress.ent &&
                                    theOrder.deliveryAddress.ent !== "" &&
                                    <div className="onRight spaceMargeRight_10">
                                        <span className="bold">כניסה: </span>
                                        <span>{theOrder.deliveryAddress.ent}</span>
                                    </div>
                                }
                            </div>
                            <div className="fullRow">
                                {theOrder.deliveryAddress.flor &&
                                    theOrder.deliveryAddress.flor !== "" &&
                                    <div className="onRight">
                                        <span className="bold">קומה: </span>
                                        <span>{theOrder.deliveryAddress.flor}</span>
                                    </div>
                                }
                                {theOrder.deliveryAddress.remarks &&
                                    theOrder.deliveryAddress.remarks !== "" &&
                                    <div className="onRight spaceMargeRight_10">
                                        <span className="bold">הערות: </span>
                                        <span>{theOrder.deliveryAddress.remarks}</span>
                                    </div>
                                }
                            </div>
                        </>
                    }
                </div>
                {
                    theOrder.orderRemarks &&
                    <>
                        <div className="fullRow">
                            <div className={"dottedLineSpacer catal spaceMargeTop_5"}></div>
                            <div className="fullRow">
                                <div className="bold big onRight">הערות נוספות</div>
                            </div>

                            <div>{theOrder.orderRemarks}</div>

                        </div>
                    </>
                }
                <div className="">
                    <div className="fullRow">
                        <div className={"dottedLineSpacer catal spaceMargeTop_5"}></div>
                        <div className="fullRow">
                            <div className="bold big spacePaddingBottom_5">תוכן ההזמנה</div>
                        </div>

                        <div>
                            {theOrder.orderItems
                                .filter((item) => item) // חיפוש פריט מתאים ב-theOrder
                                .map((orderItem, orderItemIndx) => {
                                    if (theOrder.OrderType === "Deliver") {
                                        delPrc = master.cityesToDeliver.filter(itm => itm.cityName === theOrder.deliveryAddress.city)[0];
                                    }
                                    return (
                                        <div key={orderItemIndx} className={`${currnetStyle.orderItemWrap}`} >
                                            <div className={"fullRow"} >
                                                <div className={`${currnetStyle.imgSide}`}>
                                                    <div className={`${currnetStyle.prodImg}`}>
                                                        <img src={`${ConnUrls.servMediasUrl}${orderItem.prodImageUrl}`} />
                                                    </div>
                                                </div>
                                                <div className={`${currnetStyle.detailsSide}`}>

                                                    <span className={"fullRow  big bold"}>{orderItem.prodName}</span>

                                                    {orderItem.prodOptions?.map((optionGroup, index) => {
                                                        const selectedOptions = optionGroup.options.filter((opt) => opt.selected); // Get selected options                                                          
                                                        return selectedOptions.length > 0 ? (
                                                            <div key={index}>
                                                                <span className={"fullRow regular"}>{optionGroup.optionName}:</span>
                                                                <div>
                                                                    {selectedOptions.map((selectedOpt, optIndex) => (
                                                                        <div key={optIndex}>
                                                                            <div className={"fullRow small"}>
                                                                                {selectedOpt.servType}
                                                                                {selectedOpt.mount > 1 ? ` כמות: ${(selectedOpt.mount)}` : ""}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                    {orderItem.remarks && orderItem.remarks !== "" &&
                                                        <div className={" regular bold"}>הערות למנה: {orderItem.remarks} </div>
                                                    }
                                                    <div className={"fullRow"}>
                                                        <div className={"regular bold"}>כמות: {orderItem.mount}</div>
                                                    </div>
                                                    <div className={"fullRow"}>
                                                        <span className={"regular bold onLeft"}>
                                                            {
                                                                myFunctions.getItemTotalPrice(orderItem)
                                                            } ₪
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"dottedLineSpacer"}></div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                <div className="fullRow">
                    <div className="fullRow">
                        <div className="bold big onRight">סטטוס ההזמנה: {theOrder.orderStatus}</div>
                    </div>
                    <div className={"dottedLineSpacer catal spaceMargeTop_5"}></div>

                </div>
                <div className={"fullRow"}>
                    <div className={`${styles.totalHead} bold onRight`}>סכום ההזמנה</div>
                    <div className={`${styles.totalHead} bold onLeft`}>{theOrder.orderPrice} ₪ </div>
                </div>
                {theOrder.OrderType === "Deliver" &&
                    <div className={"fullRow"}>
                        <div className={`${styles.totalHead} bold onRight`}>משלוח ({delPrc.cityName})</div>
                        <div className={`${styles.totalHead} bold onLeft`}>
                            {delPrc.delivPrice} ₪
                        </div>
                    </div>
                }
                <div className={"fullRow"}>
                    <div className={`${styles.totalHead} bold onRight`}>סה"כ</div>
                    <div className={`${styles.totalHead} bold onLeft`}>{theOrder.totalPrice} ₪ </div>
                </div>

                <div className={`${styles.totalHead} bold centerText`}>כל המחירים בשקלים וכוללים מע"מ</div>
            </div>
        </>


    )
};

export default OrdersHistoryItem;
